import { render, staticRenderFns } from "./Radar copy.vue?vue&type=template&id=6be09350&scoped=true"
import script from "./Radar copy.vue?vue&type=script&lang=js"
export * from "./Radar copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be09350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be09350')) {
      api.createRecord('6be09350', component.options)
    } else {
      api.reload('6be09350', component.options)
    }
    module.hot.accept("./Radar copy.vue?vue&type=template&id=6be09350&scoped=true", function () {
      api.rerender('6be09350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/Radar copy.vue"
export default component.exports